<template>
  <div id="app" class="wrap">
    <header-component :scrollPosition="scrollPosition" :isShow="isShow" @update:isShow="updateIsShow"></header-component>

    <!-- header -->
    <!-- Visual -->
    <section class="main-visual" :class="{ hide: isShow }">
      <div class="slick-list">
        <div class="main-visual_video-wrap">
          <div class="main-visual_video-inner">
            <video id="video1" class="main-visual_video" autoplay playsinline muted loop playbackRate="0.8" component-to-re-render :key="componentKey" ref="videoElement">
              <source src="../assets/KakaoTalk_20230327_110805659.mp4" />
            </video>
          </div>
        </div>
        <div class="main-visual_inner">
          <div class="inner">
            <div class="main-visual_text-wrap">
              <h2 id="visual-title" class="main-visual_title white">Agape</h2>
              <p id="visual-text" class="main-visual_text">몽골 땅에 하나님의 사랑을 전합니다.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--// Visual -->
    <div class="slide_wrap">
      <div class="slider_img">
        <img src="../assets/ICON_NEWS.png" style="height: 20px" />
        <p>공지사항</p>
      </div>
      <div class="slider-container">
        <div class="slider" ref="slider">
          <div class="slide" v-for="(news, index) in notices" :key="index" v-on:click="fnView2(news.seq, news.news_org)">
            {{ news.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="outline" style="height: 30vh">
      <div class="inner">
        <div class="text-wrap_wrap" style="text-align: center">
          <h3 class="title-large" style="padding-top: 5vh">
            <p class="move_top">
              몽골아가페기독병원은 세상이 추구하는 세상적으로 성공한 병원 보다는 세상의 병원이 관심을 갖지 않고 오히려 피하는 소외 계층의 환자들에게 관심을 가지고
              초점을 맞추고 있습니다.
            </p>
          </h3>
        </div>
      </div>
    </div>
    <!-- Main Product -->
    <section class="main-product" :class="{ hide: isShow }">
      <div class="inner">
        <div class="text-wrap">
          <div class="text-wrap_wrap">
            <h3 class="title-xlarge">
              <span class="title-circle_text">사업</span>
            </h3>
          </div>
        </div>
        <div class="main-product_wrap">
          <ul class="main-product_list row">
            <li class="main-proudct_item first col-md-6 col-sm-12">
              <div class="main-product_box">
                <div class="main-product_inner">
                  <router-link to="/hospital">
                    <div class="main-product_text-wrap">
                      <h4 class="main-product_title">병원진료</h4>
                    </div>
                    <figure class="main-product_img-wrap">
                      <img src="../assets/hospital/Enhuush_emch_copy.jpg" class="main-product_img" />
                    </figure>
                    <div class="main-product_text-wrap">
                      <p class="main-product_text">
                        몽골아가페기독병원은 한국 의료 선교사를 통해 몽골 의료 서비스를 향상시키고 진료과별 몽골 청년 전문의를 세워가며, 함께 환자를 치료하고
                        섬기고 있습니다.
                      </p>
                    </div>
                  </router-link>
                </div>
              </div>
            </li>
            <li class="main-proudct_item first col-md-6 col-sm-12">
              <div class="main-product_box">
                <div class="main-product_inner">
                  <router-link to="/move">
                    <div class="main-product_text-wrap">
                      <h4 class="main-product_title">이동진료</h4>
                    </div>
                    <figure class="main-product_img-wrap">
                      <img src="../assets/move/KakaoTalk_20230226_102523382_02.jpg" class="main-product_img" />
                    </figure>
                    <div class="main-product_text-wrap">
                      <p class="main-product_text">
                        몽골의 오지, 의료소외 지역을 찾아가 질병으로 고통받는 사람에게 진료를 제공하고 복음을 전하여 선교 병원의 역할을 다하고 있습니다.
                      </p>
                    </div>
                  </router-link>
                </div>
              </div>
            </li>
            <li class="main-proudct_item first col-md-6 col-sm-12">
              <div class="main-product_box">
                <div class="main-product_inner">
                  <router-link to="/salvation">
                    <div class="main-product_text-wrap">
                      <h4 class="main-product_title">구제사역</h4>
                    </div>
                    <figure class="main-product_img-wrap">
                      <img src="../assets/salvation/KakaoTalk_20230225_221750901_07.jpg" class="main-product_img" />
                    </figure>
                    <div class="main-product_text-wrap">
                      <p class="main-product_text">
                        극빈자 진료 지원,노숙인 무료 치료 및 수술, 노숙인 샤워비 및 의복 제공, 국립정신병원 무연고환자 돌보기, 정신질환자 들의 자활촌 지원을
                        합니다.
                      </p>
                    </div>
                  </router-link>
                </div>
              </div>
            </li>
            <li class="main-proudct_item first col-md-6 col-sm-12">
              <div class="main-product_box">
                <div class="main-product_inner">
                  <router-link to="/edu">
                    <div class="main-product_text-wrap">
                      <h4 class="main-product_title">의료인교육</h4>
                    </div>
                    <figure class="main-product_img-wrap">
                      <img src="../assets/edu/semina.jpg" class="main-product_img" />
                    </figure>
                    <div class="main-product_text-wrap">
                      <p class="main-product_text">
                        의료인 교육은 이곳 몽골 땅의 의료 자립을 돕고 생명을 살리는 소명과 사명에 사랑과 헌신의 마음을 품는 의료인을 세우는 제자 양육
                        사역입니다.
                      </p>
                    </div>
                  </router-link>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="main-pr" :class="{ hide: isShow }">
      <div class="inner">
        <div class="text-wrap">
          <div class="main-pr_titles">
            <h3 class="title-xlarge">
              <span class="title-circle_text">활동 소식</span>
            </h3>
          </div>
          <router-link to="/news" class="btn-arrow"><span class="btn-arrow_text">더 보기</span><i class="btn-arrow_icon xi-long-arrow-right"></i></router-link>
        </div>
        <div class="main-pr_wrap">
          <a class="main-pr_list" v-for="(news, idx) in posts" :key="idx">
            <div class="main-pr_item-title">{{ news.title }}</div>
            <div v-html="news.CONTENT" class="main-pr_item-text" v-on:click="fnView(news.seq, news.news_org)"></div>
            <div class="main-pr_item-date">{{ news.news_dt }}</div>
          </a>
        </div>
      </div>
    </section>

    <section class="main-donation" :class="{ hide: isShow }">
      <div class="inner">
        <div class="main-donation_wrap">
          <div class="text-wrap">
            <div class="text-wrap_wrap">
              <h3 class="title-xlarge">
                <span class="title-circle_text">후원</span>
              </h3>
            </div>
          </div>
        </div>
        <div class="donation_img-wrap row gy-2">
          <button @click="opendonation2()" class="donation_btn col-lg-6 col-sm-12" style="padding-left: 0; background: white; border: 0">
            <img src="../assets/donation_3.png" style="width: 100%; background: white; border: 0; height: 100%" />
          </button>
          <div class="donation_text-wrap col-lg-6 col-sm-12"  @click="opendonation2()">
          <ul>
            <li>
              <p class="donation_text_top" style="font-size: 32px; font-weight: 600; padding-top: 100px">후원 문의</p>
            </li>
            <li>
              <p class="donation_text_sec" style="padding-top:40px">사단법인 월드휴먼브리지 TEL : 1670-7618</p>
            </li>            
            <li>
              <p>후원계좌 IBK 기업은행 341-050240-04-055</p>
            </li>
          </ul>
        </div>
        </div>
      </div>
    </section>

    <section class="main-video" :class="{ hide: isShow }">
      <div class="inner">
        <div class="main-video_wrap">
          <iframe
            src="https://www.youtube.com/embed/kEw8iDV303s"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </section>

    <section class="main-location" :class="{ hide: isShow }">
      <GoogleMap
        api-key="AIzaSyBg4iVUeGpqpDPs1_FA1pCGFLRSh3JoYkQ"
        style="width: auto; height: 500px; margin: auto"
        :center="center"
        :zoom="15"
        class="main-location_map"
      >
        <Marker :options="markerOptions" class="main-location_marker" />
      </GoogleMap>
    </section>

   <footer-component></footer-component>
    <router-view></router-view>
  </div>
</template>

<script>
import '../assets/css/common.css'
import { GoogleMap, Marker } from 'vue3-google-map'
import HeaderComponent from './headerComponent.vue';
import FooterComponent from './footerComponent.vue';

export default {
  name: 'App',
  components: {
    GoogleMap,
    Marker,
    HeaderComponent,
    FooterComponent,
  },
  setup() {
    const center = { lat: 47.857594, lng: 106.756926 }
    const markerOptions = { position: center, clickable: true }

    return { center, markerOptions, scrollPosition: 0}
  },
  data: function () {
    return {
      videoIndex: 0,
      show: true,
      isShow: false,
      componentKey: 0,
      posts: [],
      notices: [],
      requestBody: {},
      currentIndex: 0,
      intervalId: null,
      textlist: [],   
    }
  },
  created() {
    this.postData()
    this.postData2()
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll)
    this.startAutoSlide()

    this.$refs.videoElement.addEventListener('contextmenu', (event) => {
      // 컨텍스트 메뉴 (우클릭 메뉴)를 비활성화하여 다운로드를 막습니다.
      event.preventDefault();
    });
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    toggleShow() {
      this.show = !this.show
    },
    forceRerender() {
      this.componentKey += 1
    },
    scollToElement() {
      this.$refs.product.scrollIntoView({ behavior: 'smooth' })
    },
    postData() {
      this.$axios
        .get('http://mkagape.org/MainNews', {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          console.log(res.staus)
          console.log(res.data)
          this.posts = res.data.rows
          for (const row of res.data.rows) {
            this.textlist.push(row.title)
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          console.log('항상 마지막에 실행')
        })
    },
    postData2() {
      this.$axios
        .get('http://mkagape.org/NoticeAll', {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          console.log(res.staus)
          console.log(res.data)
              this.notices.push(res.data.rows[0]);
              this.notices.push(res.data.rows[0]);
              this.notices.push(res.data.rows[0]);
              this.notices.push(res.data.rows[0]);
              this.notices.push(res.data.rows[0]);
              this.notices.push(res.data.rows[0]);
              this.notices.push(res.data.rows[0]);
              this.notices.push(res.data.rows[0]);
              this.notices.push(res.data.rows[0]);
              this.notices.push(res.data.rows[0]);
          })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          console.log('항상 마지막에 실행')
        })
    },
    mobileOpen() {
      this.isShow = !this.isShow
    },
     opendonation2() {
      window.location.href = 'https://whb.or.kr/140';
    },
    fnView(seq, org) {
      if (org == null || org == undefined) {
        this.requestBody.seq = seq
        console.log(this.requestBody)
        this.$router.push({
          path: '/home_news',
          query: this.requestBody,
        })
      } else {
        window.open(org, '_blank')
      }
    },
    fnView2(seq, org) {
      if (org == null || org == undefined) {
        this.requestBody.seq = seq
        console.log(this.requestBody)
        this.$router.push({
          path: '/home_notice',
          query: this.requestBody,
        })
      } else {
        window.open(org, '_blank')
      }
    },
    startAutoSlide() {
      this.intervalId = setInterval(() => {
        if (this.currentIndex === this.notices.length - 1) {
          this.currentIndex = 0
        } else {
          this.currentIndex++
        }
        this.slideTo(this.currentIndex)
      }, 5000)
    },
    slideTo(index) {
      const slider = this.$refs.slider
      slider.style.transform = `translateX(-${index * 100}%)`
    },
    stopAutoSlide() {
      clearInterval(this.intervalId)
    },
  },
  beforeRouteLeave() {
    clearInterval(this.intervalId)
  },
  computed: {
    subTitle() {
      let arr = []
      this.posts.forEach(function (value) {
        if (value.CONTENT != undefined) {
          arr.push(value.CONTENT)
        }
      })
      return arr
    },
  },
}
</script>

<style>
.v-enter-active {
  transition: opacity 1s ease;
}

.v-leave-active {
  transition: opacity 0.1s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.slider-container {
  width: 70%;
  overflow: hidden;
  text-align: center;
  margin-right: auto;
}

.slider {
  display: flex;
  transition: transform 0.5s ease-in-out;
  height: 100%;
  align-items: center;
}

.slide {
  flex: 0 0 100%;
  color: white;
  font-size: 18px;
  cursor: pointer;
}

.slide:hover {
  color: black;
}

.slide_wrap {
  display: flex;
  justify-content: center;
  align-content: center;
  background: cornflowerblue;
  margin-top: -7px;
}

.slider_img {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 20%;
}
.slider_img p {
  margin-bottom: 0;
  color: white;
  font-size: 18px;
}

@media (max-width: 640px) {
  .slider_img p {
    display: none;
  }
  .slide {
    font-size: 16px;
  }
}

.main-product_inner a:hover {
  color: initial;
}

@import '../assets/css/style.css';
</style>
